import React, { useContext, useEffect, useState } from 'react';
import { withRouter } from 'react-router-dom';
import _ from 'lodash';
import { connect } from 'react-redux';
import InputMask from 'react-input-mask';
import withForm from 'modules/common/hoc/withForm';
import Modal from 'modules/common/components/Modal';
import useFormValidator from 'useFormValidator';
import PropTypes from 'prop-types';
import moment from 'moment';
import Alert from 'react-s-alert';
import Select from 'react-select';
import { ModalContext } from 'App';
import { customStyle } from 'helper';
import DateInputPicker from 'modules/common/components/DateInputPicker2';
import DragAndDrop from 'modules/common/components/DragAndDrop';
import ImagePlaceholder from 'assets/img/image-placeholder.jpg';
import OwnerComponent from '../components/OwnerComponent';
import * as actions from '../action';
import * as c from '../constant';

const RULES = {
  tab0: {
    rules: {
      rptax_transaction_code_id: 'required',
    },
  },
  tab1: {
    defaultRules: {},
    rules: {
      TR: {
        oct_tct_cloa_no: 'required',
        oct_tct_cloa_dated: 'required',
        rptax_owner_id: 'required',
        // memoranda: 'required',
      },
      SD: {
        number_of_parcels: 'required',
        // total_remaining_area: 'required'
      },
      CS: {
        // number_of_parcels: "required",
      },
      DP: {},
      DC: {
        property_district_id: 'required',
        property_barangay_id: 'required',
        property_street: 'required',
        property_boundaries_north: 'required',
        property_boundaries_south: 'required',
        property_boundaries_east: 'required',
        property_boundaries_west: 'required',
        property_boundaries_land_sketch_photo_url: 'required',
        tdn: 'required',
        arp_no: 'required',
        pin: 'required',
        lot_no: 'required',
        blk: 'required',
        rptax_owner_id: 'required',
        administrator_beneficial_user: 'required',
        administrator_beneficial_address: 'required',
        administrator_beneficial_telephone_no: 'required|tel_number',
        administrator_beneficial_tin: 'required',
        oct_tct_cloa_no: 'required',
        oct_tct_cloa_dated: 'required',
        registered: 'required',
        survey_no: 'required',
        effectivity_of_assessment_reassessment_yr: 'required',
        effectivity_of_assessment_reassessment_qtr: 'required',
        appraised_assessed_at: 'required',
        recommending_by_id: 'required',
        recommending_at: 'required',
        approved_by_id: 'required',
        approved_at: 'required',
        // memoranda: 'required',
        appraised_assessed_by_id: 'required',
      },
    },
  },
};

const quarterList = [
  { label: '1ST QUARTER', value: '1' },
  { label: '2ND QUARTER', value: '2' },
  { label: '3RD QUARTER', value: '3' },
  { label: '4TH QUARTER', value: '4' },
];

// const years = _.range(1970, +moment().format('YYYY') + 1).sort((a, b) => b - a);
const years = _.range(
  +moment().format('YYYY'),
  +moment().format('YYYY') + 2
).sort((a, b) => b - a);

function TransactionModal({
  createRichTextEditor,
  createChangeApplication,
  history,
  getLandApplicationsList,
  getSingleLandApplication,
  getTransactionCodesList,
  getPersonOfConcernList,
  getLandOwnerList,
  transactionList,
  personOfConcernList,
  ownerList,
  findTdn,
  draftToHtml,
  convertToRaw,
  formData,
  setFormData,
  isLoading,
  isSearching,
  isLoadingLandApp,
  getProvinceList,
  provinceList,
  getDistrictList,
  districtList,
  getBarangayList,
  barangayList,
  getLocationList,
  locationList,
  getTdn,
  getPin,
  createUploader,
  getTaxEffectivityPeriods,
  taxEffectivityPeriod,
}) {
  const [tab, setTab] = useState(0);
  const [pinEnable, setPinEnable] = useState(false);
  const [form, setForm] = useState({
    ...c.DEFAULT_FORM,
    appraised_assessed_at: `${moment(new Date()).format(
      'YYYY-MM-DD HH:mm'
    )}:00`,
    recommending_at: `${moment(new Date()).format('YYYY-MM-DD HH:mm')}:00`,
    approved_at: `${moment(new Date()).format('YYYY-MM-DD HH:mm')}:00`,
  });

  const [landListData, setLandListData] = React.useState({
    land_application_id: [],
  });

  const tab0Validator = useFormValidator(
    form,
    RULES.tab0.rules,
    RULES.tab0.message
  );

  const tab1Validator = useFormValidator(
    form,
    RULES.tab1.defaultRules,
    RULES.tab1.message
  );

  useEffect(() => {
    if (!_.isEmpty(form.code)) {
      tab1Validator.onSetObjectRules(
        RULES.tab1.rules[_.get(form, 'code')]
          ? RULES.tab1.rules[_.get(form, 'code')]
          : RULES.tab1.defaultRules
      );
    }
  });

  const tab0Field = _.pick(form, ['rptax_transaction_code_id']);

  const tab1Field = _.pick(form, [
    'land_application_id',
    'oct_tct_cloa_no',
    'rptax_owner_id',

    'property_district_id',
    'property_barangay_id',
    'property_street',
    'property_boundaries_north',
    'property_boundaries_south',
    'property_boundaries_east',
    'property_boundaries_west',
    'property_boundaries_land_sketch_photo_url',
    'tdn',
    'arp_no',
    'pin',
    'lot_no',
    'blk',
    'rptax_owner_id',
    'administrator_beneficial_user',
    'administrator_beneficial_address',
    'administrator_beneficial_telephone_no',
    'administrator_beneficial_tin',
    'effectivity_of_assessment_reassessment_yr',
    'effectivity_of_assessment_reassessment_qtr',
    'appraised_assessed_by_id',
    'appraised_assessed_at',
    'recommending_by_id',
    'recommending_at',
    'approved_by_id',
    'approved_at',
  ]);

  useEffect(() => {
    tab0Validator.validate();
  }, [Object.values(tab0Field).join(',')]);

  useEffect(() => {
    tab1Validator.validate();
  }, [Object.values(tab1Field).join(',')]);

  const validateForm = () => {
    if (tab === 0) {
      if (!tab0Validator.response.is_passed) {
        return false;
      }

      return setTab(+tab + 1);
    }

    if (tab === 1) {
      if (!tab1Validator.response.is_passed) {
        return false;
      }
    }

    return true;
  };

  const paginateButton = () => {
    return (
      <>
        {tab !== 1 && (
          <div className="col-12 d-flex justify-content-center mt-3">
            {/* onClick={onSetTab(+tab+1)} */}
            {tab !== 0 && (
              <button
                type="button"
                onClick={() => setTab(+tab - 1 < 0 ? 0 : +tab - 1)}
                className="btn cms-bg-color-light mr-1"
              >
                Previous
              </button>
            )}
            <button
              type="submit"
              className="btn button-proceed ml-1 cms-bg-color-primary text-white"
              disabled={tab === 0 && !tab0Validator.response.is_passed}
            >
              Proceed
            </button>
          </div>
        )}
        {tab === 1 && (
          <div className="col-12 d-flex justify-content-center mt-3">
            <button
              type="button"
              onClick={() => {
                setTab(+tab - 1 < 0 ? 0 : +tab - 1);
                setForm({
                  ...c.DEFAULT_FORM,
                  rptax_transaction_code_id: _.get(
                    form,
                    'rptax_transaction_code_id'
                  ),
                  appraised_assessed_at: `${moment(new Date()).format(
                    'YYYY-MM-DD HH:mm'
                  )}:00`,
                  recommending_at: `${moment(new Date()).format(
                    'YYYY-MM-DD HH:mm'
                  )}:00`,
                  approved_at: `${moment(new Date()).format(
                    'YYYY-MM-DD HH:mm'
                  )}:00`,
                });
                setLandListData({
                  land_application_id: [],
                });
              }}
              className="btn cms-bg-color-light mr-1"
            >
              Previous
            </button>
            <button
              disabled={
                (tab === 1 && !tab1Validator.response.is_passed) ||
                isLoading ||
                (['CS', 'DC', 'PC', 'DP', 'D', 'R', 'TR'].indexOf(
                  _.get(form, 'code')
                ) > -1 &&
                  _.isEmpty(formData?.memoranda))
              }
              type="submit"
              className="btn button-proceed ml-1 cms-bg-color-primary text-white"
            >
              {isLoading ? (
                <i className="fa fa-spin fa-spinner" />
              ) : (
                <>Proceed</>
              )}
            </button>
          </div>
        )}
      </>
    );
  };

  const setModal = useContext(ModalContext);

  const yearOptionsSDCD =
    ['SD', 'CS', 'DP', 'PC', 'D', 'R'].indexOf(_.get(form, 'code')) > -1
      ? taxEffectivityPeriod?.map((i) => {
          return {
            label: i.year,
            value: i.year,
          };
        })
      : years.map((year) => ({
          label: year,
          value: year,
        }));

  const quarterOptionsSDCD =
    ['SD', 'CS', 'DP', 'PC', 'D', 'R'].indexOf(_.get(form, 'code')) > -1
      ? taxEffectivityPeriod
          .find((i) => +i.year === +_.get(form, 'tax_effectivity_year'))
          ?.quarter?.map((quarter) => ({
            label: quarterList.find((option) => +option.value === +quarter)
              .label,
            value: quarter,
          }))
      : quarterList;

  useEffect(() => {
    getTransactionCodesList({ status: 1, is_land: 1 });
    getPersonOfConcernList();
  }, []);
  
  useEffect(() => {
    if (
      ['SD', 'CS', 'DP', 'PC', 'D', 'R'].indexOf(_.get(form, 'code')) > -1 &&
      landListData.land_application_id[0]?.land_application_id
    ) {
      getTaxEffectivityPeriods(
        landListData.land_application_id[0].land_application_id,
        {
          rptax_transaction_code_id: _.get(form, 'rptax_transaction_code_id'),
        }
      );
    }
  }, [
    _.get(form, 'rptax_transaction_code_id'),
    landListData.land_application_id,
  ]);

  useEffect(() => {
    getLandOwnerList();
  }, []);

  const handleOnSubmit = (e) => {
    e.preventDefault();
    let args = {};

    if (validateForm() !== true) {
      return false;
    }

    if (['DP', 'PC', 'D', 'R'].indexOf(form.code) > -1) {
      args = {
        memoranda: draftToHtml(
          convertToRaw(formData.memoranda.getCurrentContent())
        ),
        rptax_transaction_code_id: _.get(form, 'rptax_transaction_code_id'),
        land_application_id: _.get(form, 'land_application_id'),
        tax_effectivity_year: _.get(form, 'tax_effectivity_year'),
        tax_effectivity_quarter: _.get(form, 'tax_effectivity_quarter'),
      };
    }

    if (['TR'].indexOf(form.code) > -1) {
      args = {
        ...form,
        memoranda: draftToHtml(
          convertToRaw(formData.memoranda.getCurrentContent())
        ),
      };
    }

    const appsId = landListData.land_application_id.map(
      (a) => a.land_application_id
    );

    if (['SD'].indexOf(form.code) > -1) {
      args = {
        rptax_transaction_code_id: _.get(form, 'rptax_transaction_code_id'),
        land_application_id: appsId,
        tax_effectivity_year: _.get(form, 'tax_effectivity_year'),
        tax_effectivity_quarter: _.get(form, 'tax_effectivity_quarter'),
        number_of_parcels: _.get(form, 'number_of_parcels'),
        total_remaining_area: _.get(form, 'total_remaining_area'),
      };
    }

    if (['CS'].indexOf(form.code) > -1) {
      args = {
        rptax_transaction_code_id: _.get(form, 'rptax_transaction_code_id'),
        land_application_id: appsId,
        tax_effectivity_year: _.get(form, 'tax_effectivity_year'),
        tax_effectivity_quarter: _.get(form, 'tax_effectivity_quarter'),
        ...(_.get(form, 'registered')
          ? {
              registered: `${moment(_.get(form, 'registered')).format(
                'YYYY-MM-DD HH:mm'
              )}:00`,
            }
          : {}),
        memoranda: draftToHtml(
          convertToRaw(formData.memoranda.getCurrentContent())
        ),
      };
    }

    if (['DC'].indexOf(form.code) > -1) {
      const finalCoOwners = [];

      (_.get(form, 'rptax_co_owners') || []).forEach((element) => {
        finalCoOwners.push(element.rptax_co_owners);
      });

      args = {
        ...form,
        ...formData,
        ...(_.get(form, 'registered')
          ? {
              registered: `${moment(_.get(formData, 'registered')).format(
                'YYYY-MM-DD HH:mm'
              )}:00`,
            }
          : {}),
        appraised_assessed_at: `${moment(
          _.get(form, 'appraised_assessed_at')
        ).format('YYYY-MM-DD HH:mm')}:00`,
        approved_at: `${moment(_.get(form, 'approved_at')).format(
          'YYYY-MM-DD HH:mm'
        )}:00`,
        recommending_at: `${moment(_.get(form, 'recommending_at')).format(
          'YYYY-MM-DD HH:mm'
        )}:00`,
        memoranda: draftToHtml(
          convertToRaw(formData.memoranda.getCurrentContent())
        ),
        rptax_co_owners: finalCoOwners,
        pin: !_.get(form, 'overwrite_pin')
          ? _.get(form, 'default_pin')
          : _.get(form, 'pin'),
      };
    }

    createChangeApplication(args, () => {
      setModal({ isOpen: false });
      getLandApplicationsList({}, ({ data }) => {
        history.push(`/rpt/land/applications/${_.get(data, '0.id')}`);
        getSingleLandApplication(_.get(data, '0.id'));
      });
    });

    return false;
  };
  const handleTransactCodeSelect = (e) => {
    setForm({
      ...form,
      rptax_transaction_code_id: e.value,
      code: e.code,
    });
  };

  const onChange = (e) => {
    return setForm({
      ...form,
      [e.target.name]:
        e.target.type === 'checkbox' ? e.target.checked : e.target.value,
    });
  };

  const handleOnChangeDate =
    (key) =>
    ({ target: { value } }) => {
      setForm({
        ...form,
        [key]: value,
      });
    };

  const ownerOptions = ownerList.map((x) => ({
    label: _.get(x, 'attributes.name'),
    value: x.id,
    id: x.id,
  }));

  const createDropDown = (list, ownerId) => {
    const newList = [];
    const filterList = _.filter(list, (selected) => +selected.id !== +ownerId);
    filterList.map((data) => {
      return newList.push({
        label: data.label,
        value: data.id,
      });
    });
    return newList;
  };

  const handleSelected = (key) => (e) => {
    setForm({
      ...form,
      ...(key === 'tax_effectivity_year'
        ? { tax_effectivity_quarter: '' }
        : {}),
      [key]: e.value,
    });
    if (key === 'property_district_id') {
      getBarangayList({
        rptax_district_id: e.value,
      });
      getLocationList({
        rptax_district_id: e.value,
      });
    }
  };

  const transactionOptions = transactionList
    .sort(
      (a, b) =>
        +_.get(a, 'attributes.sequence') - +_.get(b, 'attributes.sequence')
    )
    .map((x) => ({
      label: _.get(x, 'attributes.name'),
      code: _.get(x, 'attributes.code'),
      value: x.id,
    }));

  const searchTdn = (e) => {
    e.preventDefault();
    findTdn(
      {
        tdn: form.tdn,
        rptax_transaction_code_id: form.rptax_transaction_code_id,
      },
      (landData) => {
        if (!_.isEmpty(landData)) {
          Alert.success('Application Found.');
          setForm({
            ...form,
            tdn: '',
          });
          if (!_.isEmpty(landData?.data?.attributes?.change_batch)) {
            getLandApplicationsList(
              { change_batch: landData?.data?.attributes?.change_batch },
              ({ data }) => {
                const consiData = data.map((item, i) => {
                  return {
                    id: i + 1,
                    land_application_id: item.id,
                    arp_no: item.attributes.arp_no,
                    pin: item.attributes.pin,
                    previous_owner: item.attributes.rptax_owner_id,
                    address: item.attributes.property_address,
                    assessed: item.attributes.appraised_assessed_by,
                    barangay_id: item.attributes.property_barangay_id,
                    total_appraisal_area: item.attributes.total_appraisal_area,
                    total_remaining_area: item.attributes.total_remaining_area,
                    changed_code_id: item.attributes.changed_code_id,
                  };
                });
                setLandListData({
                  land_application_id: (
                    landListData.land_application_id || []
                  ).concat(consiData),
                });
              }
            );
          }

          if (
            !_.isEmpty(
              landListData.land_application_id.find(
                (item) =>
                  _.get(item, 'land_application_id') === landData.data.id
              )
            )
          ) {
            Alert.warning(`${landData.data.attributes.arp_no} already added.`);
          }
          if (
            _.isEmpty(
              landListData.land_application_id.find(
                (item) =>
                  _.get(item, 'land_application_id') === landData.data.id
              )
            ) &&
            _.isEmpty(landData?.data?.attributes?.change_batch)
          ) {
            setLandListData({
              land_application_id: (
                landListData.land_application_id || []
              ).concat([
                {
                  id:
                    (_.get(
                      landListData,
                      `land_application_id.${
                        landListData.land_application_id.length - 1
                      }.id`
                    ) || 0) + 1,
                  land_application_id: landData.data.id,
                  arp_no: landData.data.attributes.arp_no,
                  pin: landData.data.attributes.pin,
                  previous_owner: landData.data.attributes.rptax_owner_id,
                  address: landData.data.attributes.property_address,
                  assessed: landData.data.attributes.appraised_assessed_by,
                  barangay_id: landData.data.attributes.property_barangay_id,
                  total_appraisal_area:
                    landData.data.attributes.total_appraisal_area,
                  total_remaining_area:
                    landData.data.attributes.total_remaining_area,
                  changed_code_id: landData.data.attributes.changed_code_id,
                },
              ]),
            });
          }
          if (form.code === 'TR') {
            // TRANSFER
            getTdn(
              { barangay_id: landData.data.attributes.property_barangay_id },
              ({ data }) => {
                setForm({
                  ...form,
                  land_application_id: landData.data.id,
                  pin: landData.data.attributes.pin,
                  previous_owner: landData.data.attributes.rptax_owner_id,
                  address: landData.data.attributes.property_address,
                  assessed: landData.data.attributes.appraised_assessed_by,
                  new_tdn: data,
                });
              }
            );
          }
          if (['DP', 'PC', 'D', 'R'].indexOf(form.code) > -1) {
            // DISPUTE
            setForm({
              ...form,
              land_application_id: landData.data.id,
              pin: landData.data.attributes.pin,
              previous_owner: landData.data.attributes.rptax_owner_id,
              address: landData.data.attributes.property_address,
              assessed: landData.data.attributes.appraised_assessed_by,
            });
          }
        } else {
          Alert.error('No Application Found.');
        }
      }
    );
  };

  const handleRemoveItem = (item) => () => {
    const newItem = {
      land_application_id: (landListData.land_application_id || []).filter(
        (x) => x.id !== item.id
      ),
    };
    setLandListData(newItem);
  };

  useEffect(() => {
    getLandOwnerList();
  }, []);

  useEffect(() => {
    getProvinceList();
  }, []);

  useEffect(() => {
    getDistrictList({
      province_id: 65,
    });
  }, []);

  useEffect(() => {
    setForm({
      ...form,
      property_province_id: 65,
    });
  }, []);

  const onChangePhoto = (key) => (data) => {
    setForm({
      ...form,
      [key]: data.cdnUrl,
    });
  };

  const createDropdownProvince = (list) => {
    const newList = [];
    list.map((data) => {
      return newList.push({
        label: data.attributes.name,
        value: data.id,
      });
    });
    return newList;
  };

  const handleBarangaySelect = (e) => {
    getTdn({ barangay_id: e.value }, (tdnData) => {
      getPin({ barangay_id: e.value }, (pinData) => {
        setForm({
          ...form,
          property_barangay_id: e.value,
          tdn: tdnData.data,
          arp_no: tdnData.data,
          pin: pinData.data,
          default_pin: pinData.data,
        });
      });
    });
  };

  const locationOptions = locationList.map((x) => ({
    label: _.get(x, 'attributes.name'),
    value: x.id,
    id: x.id,
  }));

  const createDropdownBarangay = (list) => {
    const newList = [];
    list.map((data) => {
      return newList.push({
        label: data.attributes.name,
        value: data.id,
      });
    });
    return newList;
  };

  const districtOptions = districtList.map((x) => ({
    label: _.get(x, 'attributes.name'),
    value: x.id,
    id: x.id,
  }));

  const handleEnablePin = (e) => {
    if (e.target.checked) {
      setPinEnable(true);
      setForm({
        ...form,
        pin: '',
        overwrite_pin: 1,
      });
    } else {
      setPinEnable(false);
      getPin(
        { barangay_id: _.get(form, 'property_barangay_id') },
        (pinData) => {
          setForm({
            ...form,
            pin: pinData.data,
            overwrite_pin: 0,
          });
        }
      );
    }
  };

  const handleChange = (key) => (data) => {
    setForm({
      ...form,
      [key]: data,
    });
  };

  const yearOptions = years.map((year) => ({
    label: year,
    value: year,
  }));

  const pocOptions = personOfConcernList.map((item) => {
    return {
      value: item.id,
      label: item.attributes.full_name,
      is_approver: item.attributes.is_approver,
      is_assessor: item.attributes.is_assessor,
      is_recommender: item.attributes.is_recommender,
    };
  });

  const handleChangeDate = (key) => (e) => {
    setFormData({
      ...formData,
      [key]: e.target.value,
    });

    setForm({
      ...form,
      [key]: e.target.value,
    });
  };

  return (
    <Modal.Body>
      <form onSubmit={handleOnSubmit}>
        {tab === 0 && (
          <>
            <div className="row">
              <div className="col-12 form-group">
                <label className="form-label">
                  Select Transaction Code &nbsp;{' '}
                  {tab0Validator.renderMessage('rptax_transaction_code_id')}
                </label>
                <div>
                  <Select
                    options={transactionOptions}
                    styles={customStyle}
                    placeholder="Select Transact Code"
                    value={
                      transactionOptions.filter(
                        (item) =>
                          +_.get(form, 'rptax_transaction_code_id') ===
                          +_.get(item, 'value')
                      ) || ''
                    }
                    onChange={(e) => {
                      handleTransactCodeSelect(e);
                    }}
                  />
                </div>
              </div>
            </div>
            <div className="text-center mt-4">{paginateButton()}</div>
          </>
        )}
        {/* Property to Transfer */}
        {tab === 1 && (
          <>
            {_.get(form, 'code') === 'TR' && (
              <div className="row">
                <div className="col-12 form-group">
                  <label className="m-0 text-color font-weight-bold">
                    Property To Transfer
                  </label>
                </div>
                <div className="col-6 form-group">
                  <label htmlFor="last_name" className="form-label">
                    ARP/TDN
                  </label>
                  <InputMask
                    className="form-control"
                    mask="aa-99999-99999"
                    alwaysShowMask
                    type="text"
                    name="tdn"
                    onChange={onChange}
                    value={_.get(form, 'tdn')}
                  />
                </div>
                <div className="search-div-transaction d-flex align-items-start ml-2 pt-4">
                  <button
                    disabled={
                      _.get(form, 'tdn') === '__-_____-_____' ||
                      _.get(form, 'tdn') === '' ||
                      isSearching
                    }
                    type="button"
                    onClick={searchTdn}
                    className="btn btn-link button-search cms-bg-color-secondary cms-outline-secondary"
                  >
                    {isSearching || isLoadingLandApp ? (
                      <i className="fa fa-spin fa-spinner" />
                    ) : (
                      <span className="icon">
                        <i className="fa fa-lg fa-search" />
                      </span>
                    )}
                  </button>
                </div>
                <div className="col-6 form-group">
                  <label className="form-label">PIN</label>
                  <input
                    className="form-control"
                    type="text"
                    name="pin"
                    value={_.get(form, 'pin') || ''}
                    disabled
                  />
                </div>
                <div className="col-6 form-group">
                  <label className="form-label">Owner</label>
                  <div>
                    <Select
                      options={ownerOptions}
                      styles={customStyle}
                      placeholder="Select Owner"
                      value={
                        ownerOptions.filter(
                          (item) =>
                            +_.get(form, 'previous_owner') ===
                            +_.get(item, 'id')
                        ) || ''
                      }
                      onChange={handleSelected('previous_owner')}
                      isDisabled
                    />
                  </div>
                </div>
                <div className="col-12 form-group">
                  <label className="form-label">Address</label>
                  <input
                    className="form-control"
                    type="text"
                    name="address"
                    value={_.get(form, 'address') || ''}
                    disabled
                  />
                </div>
                <div className="col-6 form-group">
                  <label className="form-label">Assessed By</label>
                  <input
                    className="form-control"
                    type="text"
                    name="assessed"
                    value={_.get(form, 'assessed') || ''}
                    disabled
                  />
                </div>

                <div className="col-12 form-group">
                  <label className="m-0 text-color font-weight-bold">
                    Transfer To
                  </label>
                </div>

                <div className="col-6 form-group">
                  <label htmlFor="last_name" className="form-label">
                    ARP/TDN
                  </label>
                  <input
                    className="form-control"
                    type="text"
                    name="new_tdn"
                    value={_.get(form, 'new_tdn')}
                    disabled
                  />
                </div>
                <div className="col-6 form-group">
                  <label className="form-label">
                    Owner &nbsp; {tab1Validator.renderMessage('rptax_owner_id')}
                  </label>
                  <div>
                    <Select
                      options={createDropDown(
                        ownerOptions,
                        _.get(form, 'previous_owner')
                      )}
                      styles={customStyle}
                      placeholder="Select Owner"
                      value={
                        createDropDown(
                          ownerOptions,
                          _.get(form, 'previous_owner')
                        ).filter(
                          (item) =>
                            +_.get(form, 'rptax_owner_id') ===
                            +_.get(item, 'value')
                        ) || ''
                      }
                      onChange={handleSelected('rptax_owner_id')}
                    />
                  </div>
                </div>
                <div className="col-6 form-group">
                  <label className="form-label">
                    OCT/TCT/CLOA No. &nbsp;{' '}
                    {tab1Validator.renderMessage('oct_tct_cloa_no')}
                  </label>
                  <input
                    className="form-control"
                    type="text"
                    name="oct_tct_cloa_no"
                    onChange={onChange}
                    value={_.get(form, 'oct_tct_cloa_no') || ''}
                  />
                </div>
                <div className="form-group col-6">
                  <label htmlFor="last_name" className="form-label">
                    OCT/TCT/CLOA Date &nbsp;
                    {tab1Validator.renderMessage('oct_tct_cloa_dated')}
                  </label>
                  <DateInputPicker
                    withTime
                    className="full-input"
                    onChange={handleOnChangeDate('oct_tct_cloa_dated')}
                    value={_.get(form, 'oct_tct_cloa_dated') || ''}
                    maxDate={new Date()}
                  />
                </div>
                <div className="col-12 form-group mt-5">
                  {createRichTextEditor(
                    { key: 'memoranda', label: 'Memoranda:' },
                    { minLength: 3, required: true }
                  )}
                </div>
              </div>
            )}
            {/* Subdivision */}
            {_.get(form, 'code') === 'SD' && (
              <div className="row">
                <div className="col-12 form-group">
                  <label className="m-0 text-color font-weight-bold">
                    Subdivision
                  </label>
                </div>
                <div className="col-6 form-group">
                  <label htmlFor="last_name" className="form-label">
                    TDN/ARP
                  </label>
                  <InputMask
                    className="form-control"
                    mask="aa-99999-99999"
                    alwaysShowMask
                    type="text"
                    name="tdn"
                    onChange={onChange}
                    value={_.get(form, 'tdn')}
                  />
                </div>
                <div className="search-div-transaction d-flex align-items-start ml-2 pt-4">
                  <button
                    disabled={
                      _.get(form, 'tdn') === '__-_____-_____' ||
                      _.get(form, 'tdn') === '' ||
                      isSearching ||
                      landListData?.land_application_id[0]?.changed_code_id
                    }
                    type="button"
                    onClick={searchTdn}
                    className="btn btn-link button-search cms-bg-color-secondary cms-outline-secondary"
                  >
                    {isSearching ? (
                      <i className="fa fa-spin fa-spinner" />
                    ) : (
                      <span className="icon">
                        <i className="fa fa-lg fa-search" />
                      </span>
                    )}
                  </button>
                </div>
                <div className="container">
                  <div className="content">
                    <table
                      className="table table-sm table-hover"
                      style={{ minWidth: '250px' }}
                    >
                      <thead className="table-header">
                        <tr>
                          <th className="w-5 py-3 cms-text-primary cms-bg-color-primary-light align-middle">
                            ARP/TDN
                          </th>
                          <th className="w-5 py-3 cms-text-primary cms-bg-color-primary-light align-middle">
                            PIN
                          </th>
                          {!landListData?.land_application_id[0]
                            ?.changed_code_id && (
                            <th className="w-5 py-3 cms-text-primary cms-bg-color-primary-light align-middle">
                              Action
                            </th>
                          )}
                        </tr>
                      </thead>
                      <tbody>
                        {(landListData.land_application_id || []).map(
                          (items) => (
                            <tr key={items.id}>
                              <td className="p-3">{items.arp_no}</td>
                              <td className="p-3">{items.pin}</td>
                              {!landListData?.land_application_id[0]
                                ?.changed_code_id && (
                                <td>
                                  <button
                                    type="button"
                                    className="btn btn-link"
                                    onClick={handleRemoveItem(items)}
                                  >
                                    <i className="far fa-trash-alt icon-delete" />
                                  </button>
                                </td>
                              )}
                            </tr>
                          )
                        )}
                      </tbody>
                    </table>
                  </div>
                </div>
                <div className="col-6 form-group">
                  <label className="form-label">Number of Parcels</label>
                  <input
                    className="form-control"
                    type="text"
                    name="number_of_parcels"
                    onChange={onChange}
                    value={_.get(form, 'number_of_parcels') || ''}
                  />
                </div>
                <div className="col-6 form-group">
                  <label className="form-label">Total Area</label>
                  <input
                    className="form-control"
                    type="number"
                    name="total_remaining_area"
                    value={
                      landListData?.land_application_id[0]?.changed_code_id
                        ? landListData?.land_application_id[0]
                            ?.total_remaining_area
                        : landListData?.land_application_id?.reduce(
                            (acc, obj) => {
                              return acc + obj?.total_appraisal_area;
                            },
                            0
                          ) || 0
                    }
                    disabled
                  />
                </div>
                <div className="col-6 form-group">
                  <label className="form-label">Tax Effectivity Year</label>
                  <Select
                    options={yearOptionsSDCD}
                    styles={customStyle}
                    placeholder="Select Year"
                    value={yearOptionsSDCD?.find(
                      (item) =>
                        item.value === _.get(form, 'tax_effectivity_year')
                    )}
                    onChange={handleSelected('tax_effectivity_year')}
                    isDisabled={_.isEmpty(landListData.land_application_id)}
                  />
                </div>
                <div className="col-6 form-group">
                  <label className="form-label">Tax Effectivity Quarter</label>
                  <Select
                    options={quarterOptionsSDCD}
                    styles={customStyle}
                    placeholder="Select Quarter"
                    value={quarterOptionsSDCD?.find(
                      (item) =>
                        item.value === _.get(form, 'tax_effectivity_quarter')
                    )}
                    onChange={handleSelected('tax_effectivity_quarter')}
                    isDisabled={_.isEmpty(landListData.land_application_id)}
                  />
                </div>
              </div>
            )}
            {/* Consolidation */}
            {_.get(form, 'code') === 'CS' && (
              <div className="row">
                <div className="col-12 form-group">
                  <label className="m-0 text-color font-weight-bold">
                    Consolidation
                  </label>
                </div>
                <div className="col-6 form-group">
                  <label htmlFor="last_name" className="form-label">
                    ARP/TDN
                  </label>
                  <InputMask
                    className="form-control"
                    mask="aa-99999-99999"
                    alwaysShowMask
                    type="text"
                    name="tdn"
                    onChange={onChange}
                    value={_.get(form, 'tdn')}
                  />
                </div>
                <div className="search-div-transaction d-flex align-items-start ml-2 pt-4">
                  <button
                    disabled={
                      _.get(form, 'tdn') === '__-_____-_____' ||
                      _.get(form, 'tdn') === '' ||
                      isSearching
                    }
                    type="button"
                    onClick={searchTdn}
                    className="btn btn-link button-search cms-bg-color-secondary cms-outline-secondary"
                  >
                    {isSearching ? (
                      <i className="fa fa-spin fa-spinner" />
                    ) : (
                      <span className="icon">
                        <i className="fa fa-lg fa-search" />
                      </span>
                    )}
                  </button>
                </div>
                <div className="container">
                  <div className="content">
                    <table
                      className="table table-sm table-hover"
                      style={{ minWidth: '250px' }}
                    >
                      <thead className="table-header">
                        <tr>
                          <th className="w-5 py-3 cms-text-primary cms-bg-color-primary-light align-middle">
                            ARP/TDN
                          </th>
                          <th className="w-5 py-3 cms-text-primary cms-bg-color-primary-light align-middle">
                            PIN
                          </th>
                          <th className="w-5 py-3 cms-text-primary cms-bg-color-primary-light align-middle">
                            Action
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        {(landListData.land_application_id || []).map(
                          (items) => (
                            <tr key={items.id}>
                              <td className="p-3">{items.arp_no}</td>
                              <td className="p-3">{items.pin}</td>
                              <td>
                                <button
                                  type="button"
                                  className="btn btn-link"
                                  onClick={handleRemoveItem(items)}
                                >
                                  <i className="far fa-trash-alt icon-delete" />
                                </button>
                              </td>
                            </tr>
                          )
                        )}
                      </tbody>
                    </table>
                  </div>
                </div>
                <div className="col-6 form-group">
                  <label className="form-label">Total Area</label>
                  <input
                    className="form-control"
                    type="number"
                    name="total_remaining_area"
                    value={
                      landListData?.land_application_id?.reduce((acc, obj) => {
                        return acc + obj?.total_appraisal_area;
                      }, 0) || ''
                    }
                    disabled
                  />
                </div>
                <div className="col-6 form-group">
                  <label className="form-label">Date Registered</label>
                  <div>
                    <DateInputPicker
                      withTime
                      className="full-input"
                      onChange={handleOnChangeDate('registered')}
                      value={
                        _.get(form, 'registered')
                          ? `${moment(_.get(form, 'registered')).format(
                              'MM-DD-YYYY HH:mm'
                            )}:00`
                          : ''
                      }
                      maxDate={new Date()}
                    />
                  </div>
                </div>
                <div className="col-6 form-group">
                  <label className="form-label">Tax Effectivity Year</label>
                  <Select
                    options={yearOptionsSDCD}
                    styles={customStyle}
                    placeholder="Select Year"
                    value={yearOptionsSDCD?.find(
                      (item) =>
                        item.value === _.get(form, 'tax_effectivity_year')
                    )}
                    onChange={handleSelected('tax_effectivity_year')}
                    isDisabled={_.isEmpty(landListData.land_application_id)}
                  />
                </div>
                <div className="col-6 form-group">
                  <label className="form-label">Tax Effectivity Quarter</label>
                  <Select
                    options={quarterOptionsSDCD}
                    styles={customStyle}
                    placeholder="Select Quarter"
                    value={quarterOptionsSDCD?.find(
                      (item) =>
                        item.value === _.get(form, 'tax_effectivity_quarter')
                    )}
                    onChange={handleSelected('tax_effectivity_quarter')}
                    isDisabled={_.isEmpty(landListData.land_application_id)}
                  />
                </div>
                <div className="col-12 form-group">
                  {createRichTextEditor(
                    { key: 'memoranda', label: 'Memoranda:' },
                    { minLength: 3 }
                  )}
                </div>
              </div>
            )}
            {/* Property To Dispute */}
            {['DP', 'PC', 'D', 'R'].indexOf(form.code) > -1 && (
              <div className="row">
                <div className="col-12 form-group">
                  <label className="m-0 text-color font-weight-bold">
                    {_.get(form, 'code') === 'DP' && 'Property To Dispute'}
                    {_.get(form, 'code') === 'PC' && 'Physical Change'}
                    {_.get(form, 'code') === 'D' && 'Destruction'}
                    {_.get(form, 'code') === 'R' && 'Reclassification'}
                  </label>
                </div>
                <div className="col-6 form-group">
                  <label htmlFor="last_name" className="form-label">
                    ARP/TDN
                  </label>
                  <InputMask
                    className="form-control"
                    mask="aa-99999-99999"
                    alwaysShowMask
                    type="text"
                    name="tdn"
                    onChange={onChange}
                    value={_.get(form, 'tdn')}
                  />
                </div>
                <div className="search-div-transaction d-flex align-items-start ml-2 pt-4">
                  <button
                    disabled={
                      _.get(form, 'tdn') === '__-_____-_____' ||
                      _.get(form, 'tdn') === '' ||
                      isSearching
                    }
                    type="button"
                    onClick={searchTdn}
                    className="btn btn-link button-search cms-bg-color-secondary cms-outline-secondary"
                  >
                    {isSearching ? (
                      <i className="fa fa-spin fa-spinner" />
                    ) : (
                      <span className="icon">
                        <i className="fa fa-lg fa-search" />
                      </span>
                    )}
                  </button>
                </div>
                <div className="col-6 form-group">
                  <label className="form-label">PIN</label>
                  <input
                    className="form-control"
                    type="text"
                    name="pin"
                    value={_.get(form, 'pin') || ''}
                    disabled
                  />
                </div>
                <div className="col-6 form-group">
                  <label className="form-label">Owner</label>
                  <div>
                    <Select
                      options={ownerOptions}
                      styles={customStyle}
                      placeholder="Select Owner"
                      value={
                        ownerOptions.filter(
                          (item) =>
                            +_.get(form, 'previous_owner') ===
                            +_.get(item, 'id')
                        ) || ''
                      }
                      onChange={handleSelected('previous_owner')}
                      isDisabled
                    />
                  </div>
                </div>
                <div className="col-12 form-group">
                  <label className="form-label">Address</label>
                  <input
                    className="form-control"
                    type="text"
                    name="address"
                    value={_.get(form, 'address') || ''}
                    disabled
                  />
                </div>
                <div className="col-6 form-group">
                  <label className="form-label">Assessed By</label>
                  <input
                    className="form-control"
                    type="text"
                    name="assessed"
                    value={_.get(form, 'assessed') || ''}
                    disabled
                  />
                </div>
                <div className="col-6" />
                <div className="col-6 form-group">
                  <label className="form-label">Tax Effectivity Year</label>
                  <Select
                    options={yearOptionsSDCD}
                    styles={customStyle}
                    placeholder="Select Year"
                    value={yearOptionsSDCD?.find(
                      (item) =>
                        item.value === _.get(form, 'tax_effectivity_year')
                    )}
                    onChange={handleSelected('tax_effectivity_year')}
                    isDisabled={_.isEmpty(landListData.land_application_id)}
                  />
                </div>
                <div className="col-6 form-group">
                  <label className="form-label">Tax Effectivity Quarter</label>
                  <Select
                    options={quarterOptionsSDCD}
                    styles={customStyle}
                    placeholder="Select Quarter"
                    value={
                      quarterOptionsSDCD?.find(
                        (item) =>
                          item.value === _.get(form, 'tax_effectivity_quarter')
                      ) || ''
                    }
                    onChange={handleSelected('tax_effectivity_quarter')}
                    isDisabled={_.isEmpty(landListData.land_application_id)}
                  />
                </div>
                <div className="col-12 form-group mt-5">
                  {createRichTextEditor(
                    { key: 'memoranda', label: 'Memoranda:' },
                    { minLength: 3, required: true }
                  )}
                </div>
              </div>
            )}
            {/* Property To Discovery / New Declaration */}
            {_.get(form, 'code') === 'DC' ? (
              <div className="row">
                <div className="col-12 py-0 mb-2">
                  <h3 className="m-0 text-color font-weight-bold">
                    Property Location
                  </h3>
                </div>
                <div className="col-6 form-group">
                  <div className="">
                    <label className="form-label">Select Province</label>
                    <div>
                      <Select
                        value={createDropdownProvince(provinceList).filter(
                          (item) => {
                            return (
                              +_.get(form, 'property_province_id') ===
                                +_.get(item, 'value') || ''
                            );
                          }
                        )}
                        isDisabled
                        styles={customStyle}
                        placeholder="Select Province"
                        options={createDropdownProvince(provinceList)}
                      />
                    </div>
                  </div>
                </div>
                <div className="col-6">
                  <label className="form-label">
                    Select District &nbsp;
                    {tab1Validator.renderMessage('property_district_id')}
                  </label>
                  <div>
                    <div>
                      <Select
                        options={districtOptions}
                        styles={customStyle}
                        placeholder="Select District"
                        value={
                          districtOptions.filter(
                            (item) =>
                              +_.get(form, 'property_district_id') ===
                              +_.get(item, 'id')
                          ) || ''
                        }
                        onChange={handleSelected('property_district_id')}
                      />
                    </div>
                  </div>
                </div>
                <div className="col-6">
                  <label className="form-label">
                    Select Barangay &nbsp;
                    {tab1Validator.renderMessage('property_barangay_id')}
                  </label>
                  <div>
                    <Select
                      options={createDropdownBarangay(barangayList)}
                      styles={customStyle}
                      placeholder="Select Barangay"
                      value={
                        createDropdownBarangay(barangayList).filter(
                          (item) =>
                            +_.get(form, 'property_barangay_id') ===
                            +_.get(item, 'value')
                        ) || ''
                      }
                      onChange={(e) => {
                        handleBarangaySelect(e);
                      }}
                    />
                  </div>
                </div>
                <div className="col-6 form-group">
                  <label className="form-label">Location</label>
                  <div>
                    <Select
                      options={locationOptions}
                      styles={customStyle}
                      placeholder="Select Location"
                      value={
                        locationOptions.filter(
                          (item) =>
                            +_.get(form, 'property_location_id') ===
                            +_.get(item, 'id')
                        ) || ''
                      }
                      onChange={handleSelected('property_location_id')}
                    />
                  </div>
                </div>
                <div className="col-6 form-group pt-1">
                  <label htmlFor="last_name" className="form-label mb-0">
                    Street &nbsp;
                    {tab1Validator.renderMessage('property_street')}
                  </label>
                  <input
                    className="form-control"
                    type="text"
                    name="property_street"
                    onChange={onChange}
                    value={_.get(form, 'property_street') || ''}
                  />
                </div>
                <h3 className="col-12 m-0 text-color font-weight-bold">
                  Boundaries
                </h3>
                <div className="col-6 form-group">
                  <label htmlFor="last_name" className="form-label mb-0">
                    North &nbsp;
                    {tab1Validator.renderMessage('property_boundaries_north')}
                  </label>
                  <input
                    className="form-control"
                    type="text"
                    name="property_boundaries_north"
                    onChange={onChange}
                    value={_.get(form, 'property_boundaries_north') || ''}
                  />
                </div>
                <div className="col-6 form-group">
                  <label htmlFor="last_name" className="form-label mb-0">
                    South &nbsp;
                    {tab1Validator.renderMessage('property_boundaries_south')}
                  </label>
                  <input
                    className="form-control"
                    type="text"
                    name="property_boundaries_south"
                    onChange={onChange}
                    value={_.get(form, 'property_boundaries_south') || ''}
                  />
                </div>
                <div className="col-6 form-group">
                  <label htmlFor="last_name" className="form-label mb-0">
                    East &nbsp;
                    {tab1Validator.renderMessage('property_boundaries_east')}
                  </label>
                  <input
                    className="form-control"
                    type="text"
                    name="property_boundaries_east"
                    onChange={onChange}
                    value={_.get(form, 'property_boundaries_east') || ''}
                  />
                </div>
                <div className="col-6 form-group">
                  <label htmlFor="last_name" className="form-label mb-0">
                    West &nbsp;
                    {tab1Validator.renderMessage('property_boundaries_west')}
                  </label>
                  <input
                    className="form-control"
                    type="text"
                    name="property_boundaries_west"
                    onChange={onChange}
                    value={_.get(form, 'property_boundaries_west') || ''}
                  />
                </div>
                <div className="col-12 py-0 mb-2">
                  <h3 className="m-0 text-color font-weight-bold">
                    Information
                  </h3>
                </div>
                <div className="col-6 form-group">
                  <label htmlFor="last_name" className="form-label">
                    TDN &nbsp;{tab1Validator.renderMessage('tdn')}
                  </label>
                  <input
                    className="form-control"
                    type="text"
                    name="tdn"
                    value={_.get(form, 'tdn') || ''}
                    disabled
                  />
                </div>
                <div className="col-6 form-group">
                  <label className="form-label">
                    ARP/TDN &nbsp;{tab1Validator.renderMessage('arp_no')}
                  </label>
                  <input
                    className="form-control"
                    type="text"
                    name="arp_no"
                    value={_.get(form, 'arp_no') || ''}
                    disabled
                  />
                </div>
                <div className="col-6 form-group">
                  <div className="d-flex">
                    <label className="form-label">
                      PIN &nbsp;{tab1Validator.renderMessage('pin')}
                    </label>
                    <label className="form-label ml-auto">
                      Overwrite PIN: &nbsp;
                      <input
                        name="pinEnable"
                        type="checkbox"
                        checked={pinEnable}
                        onChange={handleEnablePin}
                        className="m-0"
                      />
                    </label>
                  </div>
                  <InputMask
                    className="form-control"
                    mask="999-99-999-999-999"
                    alwaysShowMask
                    type="text"
                    name="pin"
                    onChange={onChange}
                    value={_.get(form, 'pin')}
                  />
                </div>
                <div className="col-6 form-group">
                  <label htmlFor="last_name" className="form-label">
                    OCT/TCT/CLOA No. &nbsp;
                    {tab1Validator.renderMessage('oct_tct_cloa_no')}
                  </label>
                  <input
                    className="form-control"
                    type="text"
                    name="oct_tct_cloa_no"
                    onChange={onChange}
                    value={_.get(form, 'oct_tct_cloa_no') || ''}
                  />
                </div>
                <div className="form-group col-6">
                  <label htmlFor="last_name" className="form-label">
                    OCT/TCT/CLOA Date &nbsp;
                    {tab1Validator.renderMessage('oct_tct_cloa_dated')}
                  </label>
                  <DateInputPicker
                    withTime
                    className="full-input"
                    onChange={handleOnChangeDate('oct_tct_cloa_dated')}
                    value={_.get(form, 'oct_tct_cloa_dated') || ''}
                    maxDate={new Date()}
                  />
                </div>
                <div className="form-group col-6">
                  <label htmlFor="last_name" className="form-label">
                    Date of Registration &nbsp;
                    {tab1Validator.renderMessage('registered')}
                  </label>
                  <DateInputPicker
                    withTime
                    className="full-input"
                    onChange={handleOnChangeDate('registered')}
                    value={
                      _.get(form, 'registered')
                        ? `${moment(_.get(form, 'registered')).format(
                            'MM-DD-YYYY HH:mm'
                          )}:00`
                        : ''
                    }
                    maxDate={new Date()}
                  />
                </div>
                <div className="col-6 form-group">
                  <label htmlFor="last_name" className="form-label mb-0">
                    Survey No. &nbsp;{tab1Validator.renderMessage('survey_no')}
                  </label>
                  <input
                    className="form-control"
                    type="text"
                    name="survey_no"
                    onChange={onChange}
                    value={_.get(form, 'survey_no') || ''}
                  />
                </div>
                <div className="col-6 form-group">
                  <label htmlFor="last_name" className="form-label mb-0">
                    Lot No. &nbsp;{tab1Validator.renderMessage('lot_no')}
                  </label>
                  <input
                    className="form-control"
                    type="text"
                    name="lot_no"
                    onChange={onChange}
                    value={_.get(form, 'lot_no') || ''}
                  />
                </div>
                <div className="col-6 form-group">
                  <label htmlFor="last_name" className="form-label mb-0">
                    Block &nbsp;{tab1Validator.renderMessage('blk')}
                  </label>
                  <input
                    className="form-control"
                    type="text"
                    name="blk"
                    onChange={onChange}
                    value={_.get(form, 'blk') || ''}
                  />
                </div>
                <div className="col-6 form-group">
                  <label className="form-label">
                    Owner &nbsp;{tab1Validator.renderMessage('rptax_owner_id')}
                  </label>
                  <div>
                    <Select
                      options={ownerOptions}
                      styles={customStyle}
                      placeholder="Select Owner"
                      value={
                        ownerOptions.filter(
                          (item) =>
                            +_.get(form, 'rptax_owner_id') ===
                            +_.get(item, 'id')
                        ) || ''
                      }
                      onChange={handleSelected('rptax_owner_id')}
                    />
                  </div>
                </div>
                <OwnerComponent
                  value={form.rptax_co_owners || []}
                  onChange={handleChange('rptax_co_owners')}
                  formData={form}
                  type={form.type}
                  setFormData={setForm}
                />
                <div className="col-6 form-group">
                  <label htmlFor="last_name" className="form-label mb-0">
                    Administrator/Beneficial User &nbsp;
                    {tab1Validator.renderMessage(
                      'administrator_beneficial_user'
                    )}
                  </label>
                  <input
                    className="form-control"
                    type="text"
                    name="administrator_beneficial_user"
                    onChange={onChange}
                    value={_.get(form, 'administrator_beneficial_user') || ''}
                  />
                </div>
                <div className="col-6 form-group">
                  <label htmlFor="last_name" className="form-label mb-0">
                    Address &nbsp;
                    {tab1Validator.renderMessage(
                      'administrator_beneficial_address'
                    )}
                  </label>
                  <input
                    className="form-control"
                    type="text"
                    name="administrator_beneficial_address"
                    onChange={onChange}
                    value={
                      _.get(form, 'administrator_beneficial_address') || ''
                    }
                  />
                </div>
                <div className="col-6 form-group">
                  <label htmlFor="last_name" className="form-label mb-0">
                    Tel. No. &nbsp;
                    {tab1Validator.renderMessage(
                      'administrator_beneficial_telephone_no'
                    )}
                  </label>
                  <InputMask
                    className="form-control"
                    mask="99-9999-9999"
                    alwaysShowMask
                    type="text"
                    name="administrator_beneficial_telephone_no"
                    onChange={onChange}
                    value={_.get(form, 'administrator_beneficial_telephone_no')}
                  />
                </div>
                <div className="col-6 form-group">
                  <label htmlFor="last_name" className="form-label mb-0">
                    Tax Identification Number &nbsp;
                    {tab1Validator.renderMessage(
                      'administrator_beneficial_tin'
                    )}
                  </label>
                  <InputMask
                    className="form-control"
                    mask="999-999-999-999"
                    type="text"
                    name="administrator_beneficial_tin"
                    onChange={onChange}
                    value={_.get(form, 'administrator_beneficial_tin') || ''}
                  />
                </div>
                <div className="col-12 py-0 mb-2">
                  <h3 className="m-0 text-color font-weight-bold">
                    General Description
                  </h3>
                </div>
                <div className="col-6 form-group">
                  <label htmlFor="last_name" className="form-label">
                    Effectivity of Assessment Year &nbsp;
                    {tab1Validator.renderMessage(
                      'effectivity_of_assessment_reassessment_yr'
                    )}
                  </label>
                  <Select
                    options={yearOptions}
                    styles={customStyle}
                    placeholder="Select Year"
                    value={yearOptions.find(
                      (item) =>
                        item.value ===
                        _.get(form, 'effectivity_of_assessment_reassessment_yr')
                    )}
                    onChange={handleSelected(
                      'effectivity_of_assessment_reassessment_yr'
                    )}
                  />
                </div>
                <div className="col-6 form-group">
                  <label htmlFor="last_name" className="form-label">
                    Effectivity of Assessment Quarter &nbsp;
                    {tab1Validator.renderMessage(
                      'effectivity_of_assessment_reassessment_qtr'
                    )}
                  </label>
                  <Select
                    options={quarterList}
                    styles={customStyle}
                    placeholder="Select Quarter"
                    value={quarterList.find(
                      (item) =>
                        item.value ===
                        _.get(
                          form,
                          'effectivity_of_assessment_reassessment_qtr'
                        )
                    )}
                    onChange={handleSelected(
                      'effectivity_of_assessment_reassessment_qtr'
                    )}
                  />
                </div>
                <div className="col-6 form-group">
                  <label htmlFor="last_name" className="form-label">
                    Appraised/Assessed By &nbsp;
                    {tab1Validator.renderMessage('appraised_assessed_by_id')}
                  </label>
                  <Select
                    options={pocOptions.filter(
                      (item) => item.is_assessor === 1
                    )}
                    styles={customStyle}
                    placeholder="Select Assessor"
                    value={yearOptions.find(
                      (item) =>
                        item.value === _.get(form, 'appraised_assessed_by_id')
                    )}
                    onChange={handleSelected('appraised_assessed_by_id')}
                  />
                </div>
                <div className="form-input-group col-6">
                  <label htmlFor="last_name" className="form-label">
                    Appraised/Assessed At: &nbsp;
                    {tab1Validator.renderMessage('appraised_assessed_at')}
                  </label>
                  <DateInputPicker
                    withTime
                    className="full-input"
                    onChange={handleChangeDate('appraised_assessed_at')}
                    value={
                      `${moment(
                        _.get(formData, 'appraised_assessed_at')
                      ).format('MM-DD-YYYY HH:mm')}:00` || ''
                    }
                    maxDate={new Date()}
                  />
                </div>
                <div className="col-6 form-group">
                  <label htmlFor="last_name" className="form-label">
                    Recommended By &nbsp;
                    {tab1Validator.renderMessage('recommending_by_id')}
                  </label>
                  <Select
                    options={pocOptions.filter(
                      (item) => item.is_recommender === 1
                    )}
                    styles={customStyle}
                    placeholder="Select Recommender"
                    value={yearOptions.find(
                      (item) => item.value === _.get(form, 'recommending_by_id')
                    )}
                    onChange={handleSelected('recommending_by_id')}
                  />
                </div>
                <div className="form-input-group col-6">
                  <label htmlFor="last_name" className="form-label">
                    Recommended At: &nbsp;
                    {tab1Validator.renderMessage('recommending_at')}
                  </label>
                  <DateInputPicker
                    withTime
                    className="full-input"
                    onChange={handleChangeDate('recommending_at')}
                    value={
                      `${moment(_.get(formData, 'recommending_at')).format(
                        'MM-DD-YYYY HH:mm'
                      )}:00` || ''
                    }
                    maxDate={new Date()}
                  />
                </div>
                <div className="col-6 form-group">
                  <label htmlFor="last_name" className="form-label">
                    Approved By &nbsp;
                    {tab1Validator.renderMessage('approved_by_id')}
                  </label>
                  <Select
                    options={pocOptions.filter(
                      (item) => item.is_approver === 1
                    )}
                    styles={customStyle}
                    placeholder="Select Approver"
                    value={yearOptions.find(
                      (item) => item.value === _.get(form, 'approved_by_id')
                    )}
                    onChange={handleSelected('approved_by_id')}
                  />
                </div>
                <div className="form-input-group col-6">
                  <label htmlFor="last_name" className="form-label">
                    Approved At: &nbsp;
                    {tab1Validator.renderMessage('approved_at')}
                  </label>
                  <DateInputPicker
                    withTime
                    className="full-input"
                    onChange={handleChangeDate('approved_at')}
                    value={
                      `${moment(_.get(formData, 'approved_at')).format(
                        'MM-DD-YYYY HH:mm'
                      )}:00` || ''
                    }
                    maxDate={new Date()}
                  />
                </div>
                <div className="col-12 form-group">
                  <h3 className="m-0 text-color font-weight-bold">
                    Upload Land Sketch:
                  </h3>
                  <div className="row d-flex">
                    <div className="col-12">
                      <div>
                        <label className="form-label">
                          Land Sketch &nbsp;
                          {tab1Validator.renderMessage(
                            'property_boundaries_land_sketch_photo_url'
                          )}
                        </label>
                      </div>
                    </div>
                    <div className="col-12">
                      <div className="form-wrapper arrow-card p-4">
                        {!_.get(
                          form,
                          'property_boundaries_land_sketch_photo_url'
                        ) ? (
                          <DragAndDrop
                            onChange={onChangePhoto(
                              'property_boundaries_land_sketch_photo_url'
                            )}
                            maxSize={2}
                            caption="JPEG. PNG. Maximum size 2MB."
                            label="Upload your Requirements here"
                            fileType="image/jpeg, image/jpg, image/png"
                          />
                        ) : (
                          <div className="bg-dark text-center py-2 pb-5 rounded">
                            <div className="d-flex justify-content-end col-1">
                              {createUploader(
                                {
                                  key: 'property_boundaries_land_sketch_photo_url',
                                  label: 'Sketch',
                                },
                                { placeholder: '  ' }
                              )}
                            </div>
                            <img
                              src={
                                !_.isObject(
                                  _.get(
                                    form,
                                    'property_boundaries_land_sketch_photo_url'
                                  ) || ''
                                )
                                  ? _.get(
                                      form,
                                      'property_boundaries_land_sketch_photo_url'
                                    ) || ImagePlaceholder
                                  : _.get(
                                      form,
                                      'property_boundaries_land_sketch_photo_url.cdnUrl'
                                    ) || ImagePlaceholder
                              }
                              className="img-fluid shadow-lg"
                              role="presentation"
                              width="70%"
                              alt=""
                            />
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-12 form-group">
                  {createRichTextEditor(
                    { key: 'memoranda', label: 'Memoranda:' },
                    { minLength: 3, required: true }
                  )}
                </div>
              </div>
            ) : (
              ''
            )}
            <br />
            <div className="text-center pt-5">{paginateButton()}</div>
          </>
        )}
      </form>
    </Modal.Body>
  );
}

TransactionModal.propTypes = {
  createRichTextEditor: PropTypes.instanceOf(Function).isRequired,
  createChangeApplication: PropTypes.instanceOf(Function).isRequired,
  history: PropTypes.instanceOf(Object).isRequired,
  getLandApplicationsList: PropTypes.instanceOf(Function).isRequired,
  getSingleLandApplication: PropTypes.instanceOf(Function).isRequired,
  getTransactionCodesList: PropTypes.instanceOf(Function).isRequired,
  getLandOwnerList: PropTypes.instanceOf(Function).isRequired,
  transactionList: PropTypes.instanceOf(Array).isRequired,
  getPersonOfConcernList: PropTypes.instanceOf(Function).isRequired,
  personOfConcernList: PropTypes.instanceOf(Array).isRequired,
  ownerList: PropTypes.instanceOf(Array).isRequired,
  findTdn: PropTypes.instanceOf(Function).isRequired,
  draftToHtml: PropTypes.instanceOf(Function).isRequired,
  convertToRaw: PropTypes.instanceOf(Function).isRequired,
  formData: PropTypes.instanceOf(Object).isRequired,
  setFormData: PropTypes.instanceOf(Function).isRequired,
  isLoading: PropTypes.bool.isRequired,
  isLoadingLandApp: PropTypes.bool.isRequired,
  isSearching: PropTypes.bool.isRequired,
  getProvinceList: PropTypes.instanceOf(Function).isRequired,
  provinceList: PropTypes.instanceOf(Array).isRequired,
  getDistrictList: PropTypes.instanceOf(Function).isRequired,
  districtList: PropTypes.instanceOf(Array).isRequired,
  getBarangayList: PropTypes.instanceOf(Function).isRequired,
  barangayList: PropTypes.instanceOf(Array).isRequired,
  getLocationList: PropTypes.instanceOf(Function).isRequired,
  locationList: PropTypes.instanceOf(Array).isRequired,
  getTdn: PropTypes.instanceOf(Function).isRequired,
  getPin: PropTypes.instanceOf(Function).isRequired,
  createUploader: PropTypes.instanceOf(Function).isRequired,
  getTaxEffectivityPeriods: PropTypes.instanceOf(Function).isRequired,
  taxEffectivityPeriod: PropTypes.instanceOf(Object).isRequired,
};

const mapStateToProps = ({ api }) => ({
  transactionList: _.get(api, `${c.GET_TRANSACTION_CODES}.list`) || [],
  personOfConcernList: _.get(api, `${c.GET_PERSON_OF_CONCERN}.list`) || [],
  ownerList: _.get(api, `${c.GET_LAND_OWNER}.list`) || [],
  isLoading: api.loading.indexOf(c.CREATE_CHANGE_APPLICATION) > -1,
  isLoadingLandApp:
    _.get(api, 'loading', []).indexOf(c.GET_LAND_APPLICATIONS) > -1,
  isSearching: api.loading.indexOf(c.FIND_TDN) > -1,
  provinceList: _.get(api, `${c.GET_PROVINCE}.list`) || [],
  districtList: _.get(api, `${c.GET_DISTRICTS}.list`) || [],
  barangayList: _.get(api, `${c.GET_BARANGAYS}.list`) || [],
  locationList: _.get(api, `${c.GET_LOCATION_LIST}.list`) || [],
  taxEffectivityPeriod:
    _.get(api, `${c.GET_TAX_EFFECTIVITY_PERIOD}.list`) || [],
});

const enhance = _.flowRight([
  withForm,
  withRouter,
  connect(mapStateToProps, {
    ...actions,
  }),
]);

export default enhance(TransactionModal);
